// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.property.LeasingPropertyOuidWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid,
  LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Path,
} from '@zg-rentals/ts-leasing-client';

import type { GetPropertyInfoFromOuidResponseDto } from '@zg-rentals/ts-leasing-client';

interface GetPropertyInfoFromOuidParams {
  ouid: string;
}

export type LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Options = UseQueryOptions<
  GetPropertyInfoFromOuidResponseDto,
  unknown,
  GetPropertyInfoFromOuidResponseDto,
  Array<string | GetPropertyInfoFromOuidParams>
>;

const LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_GetKey = (getParams: GetPropertyInfoFromOuidParams) => [
  LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Path,
  getParams,
];

/**
 * get property data for listing from ouid
 */
export const useLeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid = (
  getParams: GetPropertyInfoFromOuidParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_GetKey(getParams),
    queryFn: () => LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid(getParams, httpClient),
  });
};
useLeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid.getKey =
  LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_GetKey;
